import { RenewalResponse } from 'types/api/renewal';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchRenewalOptions = {
  accessToken: string;
  sessionId: string;
};

export default function fetchRenewal({
  accessToken,
  sessionId
}: FetchRenewalOptions): FetchResponse<RenewalResponse> {
  return fetchReq({
    body: {
      grant_type: 'access_token_renewal'
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-THMID': sessionId
    },
    mark: 'renewal',
    method: 'POST',
    url: endpoints.token.renewal
  });
}
